var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 80 80"}},[_c('path',{attrs:{"d":"M80 40A40 40 0 1140 0a40 40 0 0140 40z","fill":"#002f6c"}}),_vm._v(" "),_c('path',{attrs:{"d":"M61.09 40A21.09 21.09 0 1140 18.91 21.09 21.09 0 0161.09 40z","fill":"#fefefe"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }